import { render, staticRenderFns } from "./LaudoAvaliacaoSocioambiental.vue?vue&type=template&id=96a179e4&scoped=true&lang=pug"
import script from "./LaudoAvaliacaoSocioambiental.vue?vue&type=script&lang=js"
export * from "./LaudoAvaliacaoSocioambiental.vue?vue&type=script&lang=js"
import style0 from "./LaudoAvaliacaoSocioambiental.vue?vue&type=style&index=0&id=96a179e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a179e4",
  null
  
)

export default component.exports